import React from "react";
import { ImCross } from "react-icons/im";
import PropTypes from "prop-types";
import "./StageBar.scss";
import Tooltip from "../Tooltip/Tooltip";
function StageBar({ stages }) {
  const isFirstStage = (index) => (index === 0 ? true : false);
  const isStageInProgress = (stage) => stage.progress > 0 && stage.progress < 100 ? true : false;
  const isStageCompleted = (stage) => (stage.progress === 100 ? true : false);
  const stageHasErrors = (stage) => stage.errorAtStage;
  return (
    <div className="stageBarContainer">
      <ul className="stageBar" aria-label="stage-bar">
        {stages.map((stage, index) => {
          return (
            <li
              className={`${isStageCompleted(stage) && "active"} ${isStageInProgress(stage) && "stage-in-progress"
                } ${stageHasErrors(stage) && "stage-error"}`}
              key={index}
            >
              {!isFirstStage(index) && (
                <div className="progress-bar-container">
                  <progress
                    className="progress-bar"
                    value={stage.progress}
                    max="100"
                    role="progressbar"
                  ></progress>
                </div>
              )}
              <div className="stage">
                {stageHasErrors(stage) && (
                  <div className="error-message-tooltip">
                    <Tooltip isPopover={false}>
                      <ImCross
                        style={{
                          color: "#DC3220",
                        }}
                        aria-label="cross-icon"
                      ></ImCross>
                      <>{stage.errorMessage}</>
                    </Tooltip>
                  </div>
                )}
                <span>{stage.stageTitle}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

StageBar.propTypes = {
  stages: PropTypes.arrayOf(
    PropTypes.shape({
      stageTitle: PropTypes.string.isRequired,
      progress: PropTypes.number.isRequired,
      errorAtStage: PropTypes.bool.isRequired,
      errorMessage: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default StageBar;
